<div class="flex gap-3">
  <mat-radio-group [formControl]="valueFormControl" aria-label="Select an option">
    <mat-radio-button [value]="values.DATE" color="primary">Date</mat-radio-button>
    <mat-radio-button [value]="values.INTERVAL" color="primary">Intervalle</mat-radio-button>
  </mat-radio-group>
</div>

